import { createSelector } from '@ngrx/store';

import {
  createEntityCollectionStore,
  memoizeSelector,
  ngrxEvent,
  pipeState,
} from '@core/ngrx-legacy';

import {
  EntityStoreKey,
  type JobTemplateEvaluationFormsEntity,
  type JobTemplateInterviewTemplate,
} from './job-template-evaluation-forms.types';

const {
  namespace,
  selectors: defaultSelectors,
  actions: defaultActions,
  reducer,
} = createEntityCollectionStore<JobTemplateEvaluationFormsEntity>()(
  EntityStoreKey.JobTemplateEvaluationForms,
  {
    idSelector: e => e.jobTemplateId,
    customActions: adapter => ({
      fetchOne: (state, payload: { jobTemplateId: number }) =>
        adapter.markAsPending(state, { scope: null, entities: [payload.jobTemplateId] }),
      fetchOneSuccess: (state, payload: { scope: null; data: JobTemplateEvaluationFormsEntity }) =>
        pipeState(adapter.upsertOne(state, payload.data), next =>
          adapter.markAsLoaded(next, { scope: null, entities: [payload.data.jobTemplateId] }),
        ),
      fetchOneFailed: ngrxEvent<{ jobTemplateId: number }>(),
    }),
  },
);

const selectors = {
  byJobTemplateId: memoizeSelector((id: number) =>
    createSelector(
      defaultSelectors.byId(id),
      (state: JobTemplateEvaluationFormsEntity | null): JobTemplateInterviewTemplate[] | null =>
        state?.jobInterviewTemplates ?? null,
    ),
  ),
  meta: defaultSelectors.meta,
};

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

export {
  actions as JobTemplateEvaluationFormsActions,
  namespace as JobTemplateEvaluationFormsNamespace,
  selectors as JobTemplateEvaluationFormsSelectors,
  reducer as JobTemplateEvaluationFormsReducer,
};
